/**
 * What the invite and add-with-key forms need before they may be sent, and
 * what to tell the user about a field that is not there yet.
 */
import { isValidEmail } from '../../lib/utils/email';

export interface MemberFormValues {
  email: string;
  name: string;
}

/** Translation keys of the messages, per field; absent when the field is fine. */
export interface MemberFormErrors {
  email?: 'TeamFieldInvalidEmail';
  name?: 'TeamFieldNameRequired';
}

export function memberFormValid(email: string, name: string): boolean {
  return isValidEmail(email) && name.trim().length > 0;
}

/**
 * The message per field. A field only speaks once it has been touched, so an
 * untouched form opens without complaints.
 */
export function memberFormErrors(
  values: MemberFormValues,
  touched: { email: boolean; name: boolean }
): MemberFormErrors {
  const errors: MemberFormErrors = {};
  if (touched.email && !isValidEmail(values.email)) {
    errors.email = 'TeamFieldInvalidEmail';
  }
  if (touched.name && values.name.trim().length === 0) {
    errors.name = 'TeamFieldNameRequired';
  }
  return errors;
}
